// DS: DEV13
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback } from 'react';
import { useFirstTimeFlag } from '../../../redux/firstTimeFlags/hooks';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
import SophisticatedTooltipBase from '@wix/da-ds/pkg/tooltips/lego/SophisticatedTooltipBase';
/**
 * A SophisticatedTooltip with the UX we expect for an FTUE tooltip.
 *
 * If `heading` isn't supplied, `aria-label` is required to fulfill a11y requirements.
 */ const SophisticatedFtueTooltip = (_param)=>{
    var { isVisible, flag, enabled = true, onClose: consumerProvidedOnClose } = _param, rest = _object_without_properties(_param, [
        "isVisible",
        "flag",
        "enabled",
        "onClose"
    ]);
    const { hasFlag, dropFlag } = useFirstTimeFlag(flag);
    const { onClick, onMouseEnter, onMouseLeave, onClose } = usePopoverOnInteraction({
        listenOnClicks: true,
        listenOnHover: true
    });
    const handleClose = useCallback(()=>{
        onClose();
        dropFlag();
        if (consumerProvidedOnClose) {
            consumerProvidedOnClose();
        }
    }, [
        onClose,
        dropFlag,
        consumerProvidedOnClose
    ]);
    return /*#__PURE__*/ React.createElement(SophisticatedTooltipBase, _object_spread({
        isVisible: !!hasFlag && enabled,
        onReferenceClick: onClick,
        onReferenceMouseEnter: onMouseEnter,
        onReferenceMouseLeave: onMouseLeave,
        onClose: handleClose
    }, rest));
};
SophisticatedFtueTooltip.displayName = 'SophisticatedFtueTooltip';
export default SophisticatedFtueTooltip;

//# sourceMappingURL=SophisticatedFtueTooltip.js.map